import { apiClient } from './client'

export type McpConnection = {
  connected: boolean
  clients: string[]
  last_authorized_at: string | null
  achievement_count: number
}

export const getMcpConnection = () =>
  apiClient.get<McpConnection>('/mcp-connection/').then((r) => r.data)

export const revokeMcpConnection = () =>
  apiClient.delete('/mcp-connection/').then((r) => r.data)
